import ACTIONS from "../actions/actionTypes"

export const selectedPlan = (state = null, action) => {
  const { type, payload } = action
  if (type === ACTIONS.SET_SELECTED_PLAN) return payload
  if (type === ACTIONS.CLEAR_SELECTED_PLAN) return null
  return state
}
